"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Accordion = ({
  children,
  header,
  ...rest
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const toggle = (0, _react.useCallback)(value => () => setExpanded(value), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledMuiAccordion, {
    "data-testid": getTestId(_constants.ACCORDION),
    expanded: expanded,
    elevation: 0,
    onChange: toggle(!expanded),
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledAccordionSummary, {
      expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        textTransform: "uppercase",
        fontWeight: "bold",
        children: header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledAccordionDetails, {
      children: children
    })]
  });
};
exports.Accordion = Accordion;